// extracted by mini-css-extract-plugin
export var answer = "faq-module--answer--8cc2a";
export var center = "faq-module--center--a1068";
export var faq = "faq-module--faq--03f38";
export var faqContainer = "faq-module--faqContainer--f803d";
export var icon = "faq-module--icon--15659";
export var iconRotated = "faq-module--iconRotated--23438";
export var question = "faq-module--question--6d150";
export var questionWrapper = "faq-module--questionWrapper--69218";
export var root = "faq-module--root--fc40e";
export var title = "faq-module--title--d2f52";